
import Vue from "vue";
import { NewBoxesApiFunc, setAccessToken } from "@/api";
import { Box, BoxStyle, BoxStatus } from "@/models";

import TheTemplate from "../../TheNoSidebarTemplate.vue";
import BaseCloseButton from "@/components/BaseCloseButton.vue";
import BaseSubmitButton from "@/components/BaseSubmitButton.vue";
import BaseCancelButton from "@/components/BaseCancelButton.vue";
import BaseChuiGaki from "@/components/BaseChuiGaki.vue";

export type DataType = {
  box?: Box;
};

export default Vue.extend({
  name: "ToiletBoxDeleteScreen",

  components: {
    BaseChuiGaki,
    TheTemplate,
    BaseCloseButton,
    BaseSubmitButton,
    BaseCancelButton,
  },

  data(): DataType {
    return {
      box: new Box(),
    };
  },

  computed: {
    name(): string {
      return this.box?.name || "";
    },

    boxStyle(): string {
      switch (this.box?.boxStyle) {
        case BoxStyle.JAPANESE:
          return "和式";
        case BoxStyle.WESTERN:
          return "洋式";
        default:
          return "不明";
      }
    },

    sensorMac(): string {
      return this.box?.sensorMac || "";
    },

    statusText(): string {
      switch (this.box?.status) {
        case BoxStatus.RUNNING:
          return "稼動";
        case BoxStatus.IN_MAINTENANCE:
          return "メンテ中";
        case BoxStatus.IN_PREPARING:
          return "準備中";
        default:
          return "不明";
      }
    },

    statusClassText(): string {
      switch (this.box?.status) {
        case BoxStatus.RUNNING:
          return "";
        case BoxStatus.IN_MAINTENANCE:
          return "red";
        case BoxStatus.IN_PREPARING:
          return "red";
        default:
          return "";
      }
    },
  },

  mounted() {
    this.getBox();
  },

  methods: {
    async getBox(): Promise<void> {
      const companyId = this.$auth.companyId;
      if (!companyId) {
        this.$router.replace({ name: "login" });
        return;
      }
      const toiletId = this.$router.currentRoute.params.toiletId;
      const boxId = this.$router.currentRoute.params.boxId;
      setAccessToken(this.$auth.accessToken);
      const { data, err } = await NewBoxesApiFunc().getBox(
        companyId,
        toiletId,
        boxId
      );

      if (err != null) {
        this.$handleApiError(err, this.getBox);
        return;
      }

      this.box = data;
    },

    async deleteBox(): Promise<void> {
      const companyId = this.$auth.companyId;
      if (!companyId) {
        this.$router.replace({ name: "login" });
        return;
      }
      this.$setLoading(true);
      const toiletId = this.$router.currentRoute.params.toiletId;
      const boxId = this.$router.currentRoute.params.boxId;
      setAccessToken(this.$auth.accessToken);
      const { err } = await NewBoxesApiFunc().deleteBox(
        companyId,
        toiletId,
        boxId
      );

      if (err != null) {
        this.$handleApiError(err, this.deleteBox);
        this.$setLoading(false);
        return;
      }
      this.$setLoading(false);
      this.$setChecked(true);
      this.$afterSuccessRequest(() => {
        this.$router.push({
          name: `company-toilet-boxes`,
          params: {
            updated: "true",
            toiletId: toiletId,
          },
        });
      }, 2);
    },

    afterLeave(): void {
      this.$setChecked(false);
    },
  },
});
